import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { loadTickerSearchList, getTickersBySymbols } from '../store/slices/globalResources.slice';



// Custom hook to ensure data is loaded
export const useEnsureTickersLoaded = (symbols) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const tickers = useSelector((state) => getTickersBySymbols(state, symbols));
  const status = useSelector((state) => state.global.status.tickerSearchList);

  useEffect(() => {
    // Only fetch tickers if they haven't been loaded yet
    if (status === 'idle' || status === 'failed') {
      setLoading(true);
      dispatch(loadTickerSearchList()).then(() => setLoading(false));
    }
  }, [status, dispatch]);

  return { tickers, loading }; // Return both tickers and loading status
};